import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage, plural } from '@/utils'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

type BulkHideMarketShopInventoryRequest = {
  ids: number[]
  buildingId: number
}

type BulkActionResponse = {
  affected: number
  failed: number[]
}

const bulkHideMarketShopInventory = async (
  data: BulkHideMarketShopInventoryRequest,
): Promise<BulkActionResponse> => {
  const response = await authAPI.post<BulkActionResponse>('/market-shop/products/bulk', {
    action: 'hide',
    ...data,
  })
  return response.data
}

export const useBulkHideMarketShopInventory = () => {
  return useMutation({
    mutationFn: bulkHideMarketShopInventory,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async ({ affected }) => {
      await resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
      toastFactory.success(
        `${plural(affected, { one: 'Item', other: 'Items' })} hidden successfully`,
      )
    },
  })
}
